function FeatureService() {
    /// <summary>
    /// Checks whether a feature is enabled or not by looking for a class on the HTML tag
    /// (similar to Modernizr). Used for CSS/JavaScript based feature switching.
    /// </summary>
    const classes = document.documentElement.className.split(/\s+/);
    this._features = {};

    for (let i = 0; i < classes.length; i++) {
        this._features[classes[i]] = true;
    }
}

FeatureService.prototype.isEnabled = function (featureName) {
    return featureName in this._features && this._features[featureName];
};

FeatureService.prototype.setFeature = function (featureName, isEnabled) {
    this._features[featureName] = isEnabled;
};

FeatureService.prototype.features = {
    responsive: 'responsive',
    onesiteProductStamp: 'onesiteproductstamp',
    fixedHeader: 'fixed-header',
    globalHeader: 'global-header',
    visualShopping: 'visual-shopping',
    smallFormat: 'small-format',
    collectionZone: 'collection-zone',
    checkout: 'conversational-checkout-wizard',
    angulax: 'angulax',
    sfExpandPersonalShopperComment: 'sf-expand-personal-shopper-comment',
    mfExpandPersonalShopperComment: 'mf-expand-personal-shopper-comment',
    lfExpandPersonalShopperComment: 'lf-expand-personal-shopper-comment',
    diagnostics: 'diagnostics',
    displayRewardsStatus: 'display-rewards-status',
    displayEdrCardStatus: 'display-edr-card-status',
    storeUrls: 'store-urls',
    visualShoppingV2: 'visual-shopping-v2',
    centerPanelSlide: 'center-panel-slide',
    homepageOnSmallFormat: 'global-homepage-on-small-format',
    checkoutPerformanceEnhancements: 'checkout-performance-enhancements',
    centerProductTag: 'center-product-tag',
    responsysTrackingPixel: 'responsys-tracking-pixel',
    pageTransitionAnimations: 'page-transition-animations',
    visualShoppingAisleRibbon: 'visual-shopping-aisle-ribbon',
    recipeSavedList: 'recipe-saved-list',
    enableShowActiveOrdersOnLogin: 'enable-show-active-orders-on-login',
    pricePoint: 'price-point',
    enableGuestAccessToLists: 'enable-guest-access-to-Lists',
    visualShoppingAisleIcons: 'visual-shopping-aisle-icons',
    clickAndCollectStoreSearch: 'click-and-collect-store-search',
    enableDiscoverLandingPage: 'enable-discover-landing-page',
    enableRecipesLandingPage: 'enable-recipes-landing-page',
    enableSpecialTypeLandingPage: 'enable-special-type-landing-page',
    multisearch: 'multisearch',
    multisearchSf: 'multisearch-sf',
    clickAndCollectPickUpInstructions: 'click-and-collect-pick-up-instructions',
    recipeSocialMedia: 'recipe-social-media',
    recipeEmailExport: 'recipe-export-email',
    recipePrintExport: 'recipe-export-print',
    disableUpdatePaymentSummary: 'update-payment-summary-disabled',
    newProductsPage: 'enable-new-products-page',
    signupWithPaypal: 'signup-with-paypal',
    checkoutWithPaypal: 'checkout-with-paypal'
};

module.exports = FeatureService;

// Provided for backwards compat with code in Behaviour.js and Shop.js
// Delete once no longer needed
if (!('wowFeatures' in window)) {
    window.wowFeatures = new FeatureService();
}


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/feature/feature-service.js
 **/